import type { ArdoqId } from '@ardoq/api-types';

export type DropzoneNodeState = {
  modelId: ArdoqId;
  isGroupNode: boolean;
  isValidDropTarget: boolean;
};

export type DropzoneHighlightState = {
  nodes: ReadonlyMap<ArdoqId, DropzoneNodeState>;
  hoveredModelId: ArdoqId | null;
};

export type DropzoneHighlightStateHolder = {
  current: DropzoneHighlightState;
};

export const emptyDropzoneHighlightState: DropzoneHighlightState = {
  nodes: new Map(),
  hoveredModelId: null,
};

export const withHoveredModelId = (
  state: DropzoneHighlightState,
  hoveredModelId: ArdoqId | null
): DropzoneHighlightState => ({ ...state, hoveredModelId });

export const isHoveredDropzone = (
  { hoveredModelId }: DropzoneHighlightState,
  { modelId }: DropzoneNodeState
): boolean => hoveredModelId !== null && modelId === hoveredModelId;
